<template>
    <div class="vertical-flow">
        <div class="registry-wrapper">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />

            <empty-table-message v-if="isEmpty" />
            <b-table v-else :data="visitaItem" class="data-table" @sort="sortTable" backend-sorting>
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{ 'excluir-field': f.key == 'excluir' }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'descricao'">
                        <a
                            @click="
                                $router.push({
                                    name: 'agro-visita-item-edit',
                                    params: { idvisita: $route.params.id, id: props.row.uuid },
                                })
                            "
                        >
                            {{ isNull(props.row[f.key]) ? '---' : cutString(props.row[f.key], 50) }}
                        </a>
                    </div>
                    <div v-else-if="f.key == 'ocorrencia'">
                        <a
                            @click="
                                $router.push({
                                    name: 'agro-visita-item-edit',
                                    params: { idvisita: $route.params.id, id: props.row.uuid },
                                })
                            "
                        >
                            {{ props.row[f.key].nomepopular }}
                        </a>
                    </div>
                    <div v-else-if="f.key == 'datahora_visita'">
                        {{ props.row[f.key] | moment('L LT') }}
                    </div>
                    <div v-else-if="f.key == 'excluir'">
                        <span v-if="permissao.delete">
                            <b-button
                                class="action-button"
                                type="is-danger"
                                icon-right="delete"
                                @click="promptDelete(props.row)"
                                v-tippy
                                :title="$t('excluir')"
                            />
                        </span>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AgroVisitaItemService from '@/services/agro/agrovisita/AgroVisitaItemService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        situacao: {
            type: Number,
            default: 0,
        },
        tipoOcorrencia: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            service: new AgroVisitaItemService(this.$http, this.$router),
            msgs: [],
            isLoading: false,
            permissao: false,
            cantEdit: false,
            isEmpty: false,
            column: 'datahora',
            order: 'asc',

            visitaItem: [],
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'ocorrencia', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                { key: 'datahora_visita', width: null, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            delete: null,
        };
    },
    watch: {
        situacao(val) {
            // verifica se a agroVisita foi finalizada, se foi bloqueia a edição
            if (val != 4) this.cantEdit = true;
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-visita' },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                // verifica se a agroVisita foi finalizada, se foi bloqueia a edição
                if (this.situacao != 4) this.cantEdit = true;

                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-visita-item-' + numberId;
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let params = [this.$route.params.id, this.tipoOcorrencia.id];

            this.service
                .findAll(this.column, this.order, currentPage - 1, this.pagination.perPage, params)
                .then(this.mapItems)
                .then((value) => {
                    this.visitaItem = Object.assign(value);
                    this.isEmpty = this.visitaItem.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                    if (this.visitaItem.length == 0) this.$emit('removeAba', true);
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    codigo: m.idagro_visitaitemerp,
                    uuid: m.uuid,
                    descricao: m.descricao,
                    ocorrencia: m.ocorrencia,
                    datahora_visita: m.datahora,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        promptDelete(row) {
            this.delete = row;
            let message = this.$t('msg-confirmacao-exclusao-n', { 
                n: this.$t('codigo') + ' ' + row.codigo + ' - ' + row.ocorrencia.nomepopular 
            });
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.deleteRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deleteRegistro() {
            this.isLoading = true;
            this.service
                .delete(this.delete.uuid)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-delete-sucesso-n', { n: this.$t('agro-visita-item') });
                        this.$root.showMessage('success', msg, true, false);

                        this.carregarDados(this.pagination.currentPage);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped></style>
